import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';



@Component({
  selector: 'app-physicianslide',
  templateUrl: './physicianslide.component.html',
  styleUrls: ['./physicianslide.component.scss']
})
export class PhysicianslideComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {
  }
  
  contact(){
    this.router.navigate(['/appypartnercontactinfo']);
  }

  Signup(){
    const redirectUrl = '/app/physician/profile/setupOrganization';
    window.location.href = `/Session/SignUp?redirectUrl=${redirectUrl}`;

    // this.router.navigate(['/Signup']);
  }

}
